import Forward from "@/views/Forward.vue";

export default (rootPath) => {
  return [
    {
      path: "",
      component: Forward,
      redirect: `${rootPath}/list`,
      hidden: true,
      children: [
        {
          path: "list",
          component: () => import("@/views/table/CitiesTable.vue"),
          meta: { title: "Список городов", activeMenuParent: true },
          hidden: true,
        },
        {
          path: "create",
          component: () => import("@/views/forms/CitiesForm.vue"),
          meta: { title: "Создать город", activeMenuParent: true },
          hidden: true,
        },
        {
          path: "edit/:id",
          component: () => import("@/views/forms/CitiesForm.vue"),
          meta: { title: "Редактировать город", activeMenuParent: true },
          hidden: true,
        },
      ],
    },
  ];
};
